export default "__VITE_ASSET__faf2f4d0__"